module.exports = __webpack_public_path__ + "img/pf.453c4725.svg";